import countriesSng from '@/constants/countries/countries';

const checkCountries = (currentCode) => {
  return countriesSng.includes(currentCode);
};

export default checkCountries;
